export default __webpack_public_path__ + "static/media/mail.ed7cc29f.svg";